/**
 * Environment and configuration utilities
 *
 */
export var isProdEnvironment = function () {
    return typeof window !== 'undefined' &&
        window.location.hostname === 'www.homedepot.com';
};
export var getGlobalRequestTimeout = function () {
    return isProdEnvironment() ? 20000 : 60000;
};
